import { httpClient } from '@/shared/api';
import type { AreaDto, CityDto, GovernorateDto } from './region.dto';

const PREFIX = '/app/region';

function toQuery(params: Record<string, string | undefined>): string {
  const search = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v != null && v !== '') search.set(k, v);
  }
  const q = search.toString();
  return q ? `?${q}` : '';
}

function appendIntIds(q: URLSearchParams, paramName: string, ids: (string | number)[]): void {
  for (const id of ids) {
    const n = typeof id === 'number' ? id : Number(String(id).trim());
    if (Number.isFinite(n)) q.append(paramName, String(n));
  }
}

export const regionApi = {
  getGovernorates: (params: { filter?: string } = {}) =>
    httpClient.get<GovernorateDto[]>(`${PREFIX}/governerates${toQuery(params)}`),

  getCities: (params: { filter?: string } = {}) =>
    httpClient.get<CityDto[]>(`${PREFIX}/cities${toQuery(params)}`),

  /** Single governorate — legacy path; prefer getGovernoratesCities for multiselect. */
  getGovernorateCities: (governorateId: string | number, params: { filter?: string } = {}) =>
    httpClient.get<CityDto[]>(`${PREFIX}/governerate-cities/${governorateId}${toQuery(params)}`),

  /** GET /api/app/region/governerates-cities?GovernerateIds=…&GovernerateIds=… */
  getGovernoratesCities: (params: { governorateIds: (string | number)[]; filter?: string }) => {
    const q = new URLSearchParams();
    appendIntIds(q, 'GovernerateIds', params.governorateIds);
    if (params.filter != null && params.filter !== '') q.set('filter', params.filter);
    const qs = q.toString();
    return httpClient.get<CityDto[]>(`${PREFIX}/governerates-cities${qs ? `?${qs}` : ''}`);
  },

  /** GET /api/app/region/cities-areas?CityIds=…&CityIds=… */
  getCitiesAreas: (params: { cityIds: (string | number)[]; filter?: string }) => {
    const q = new URLSearchParams();
    appendIntIds(q, 'CityIds', params.cityIds);
    if (params.filter != null && params.filter !== '') q.set('filter', params.filter);
    const qs = q.toString();
    return httpClient.get<AreaDto[]>(`${PREFIX}/cities-areas${qs ? `?${qs}` : ''}`);
  },
};
